module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/3@2x_058b9cfb967b3131152a3f7f6c6361ea.png";